import { ThunkAction, ThunkDispatch } from "redux-thunk";

import { getBasicData, getPresentationId, State } from "../reducers";
import { updateBasicData } from "../services/presentation-store";
import { Undoable } from "./undo";
import { reportError, ReportErrorAction } from "./ui-state";


export interface SetGoalsAction extends Undoable {
    readonly type: 'SET_GOALS',
    readonly oldGoals: string,
    readonly newGoals: string,
}

export interface SetMainMessageAction extends Undoable {
    readonly type: 'SET_MAIN_MESSAGE',
    readonly oldMainMessage: string,
    readonly newMainMessage: string,
}

export interface SetAudienceAction extends Undoable {
    readonly type: 'SET_AUDIENCE',
    readonly oldAudience: string,
    readonly newAudience: string,
}

export function setGoals(newGoals: string): ThunkAction<any, State, any, SetGoalsAction | ReportErrorAction> {
    return async (dispatch: ThunkDispatch<State, any, SetGoalsAction | ReportErrorAction>, getState: () => State): Promise<any> => {
        const state = getState();
        const presentationId = getPresentationId(state);
        const oldBasicData = getBasicData(state);
        const oldGoals = oldBasicData.goals;
        const redoEffect = async () => await updateBasicData(presentationId, newGoals, oldBasicData.mainMessage, oldBasicData.audience)
            .catch(error => dispatch(reportError(error)));
        const undoEffect = async () => await updateBasicData(presentationId, oldGoals, oldBasicData.mainMessage, oldBasicData.audience)
            .catch(error => dispatch(reportError(error)));
        dispatch({
            type: 'SET_GOALS',
            oldGoals,
            newGoals,
            redoEffect,
            undoEffect,
        });
        await redoEffect();
    };
}

export function setMainMessage(newMainMessage: string): ThunkAction<any, State, any, SetMainMessageAction | ReportErrorAction> {
    return async (dispatch: ThunkDispatch<State, any, SetMainMessageAction | ReportErrorAction>, getState: () => State): Promise<any> => {
        const state = getState();
        const presentationId = getPresentationId(state);
        const oldBasicData = getBasicData(state);
        const oldMainMessage = oldBasicData.mainMessage;
        const redoEffect = async () => await updateBasicData(presentationId, oldBasicData.goals, newMainMessage, oldBasicData.audience)
            .catch(error => dispatch(reportError(error)));
        const undoEffect = async () => await updateBasicData(presentationId, oldBasicData.goals, oldMainMessage, oldBasicData.audience)
            .catch(error => dispatch(reportError(error)));
        dispatch({
            type: 'SET_MAIN_MESSAGE',
            oldMainMessage,
            newMainMessage,
            redoEffect,
            undoEffect,
        });
        await redoEffect();
    };
}

export function setAudience(newAudience: string): ThunkAction<any, State, any, SetAudienceAction | ReportErrorAction> {
    return async (dispatch: ThunkDispatch<State, any, SetAudienceAction | ReportErrorAction>, getState: () => State): Promise<any> => {
        const state = getState();
        const presentationId = getPresentationId(state);
        const oldBasicData = getBasicData(state);
        const oldAudience = oldBasicData.audience;
        const redoEffect = async () => await updateBasicData(presentationId, oldBasicData.goals, oldBasicData.mainMessage, newAudience)
            .catch(error => dispatch(reportError(error)));
        const undoEffect = async () => await updateBasicData(presentationId, oldBasicData.goals, oldBasicData.mainMessage, oldAudience)
            .catch(error => dispatch(reportError(error)));
        dispatch({
            type: 'SET_AUDIENCE',
            oldAudience,
            newAudience,
            redoEffect,
            undoEffect,
        });
        await redoEffect();
    };
}




// WEBPACK FOOTER //
// ./src/actions/basic-data.ts